import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Partner } from '@chancenwerk/master-data-management/partner/entities/Partner.js';
import { WorkshopTrainingAttendance } from '@chancenwerk/workshops/entities/WorkshopTrainingAttendance.js';

/**
 * @entity WorkshopAttendance
 */
@Entity()
export class WorkshopAttendance extends WorkshopTrainingAttendance {
  public static override _class = 'WorkshopAttendance';
  public static override _collectionName = 'workshop-attendance';

  @DataLoadedField(type => Partner, ({ partnerID }) => partnerID)
  public partner: Maybe<Partner>;

  @Field(type => String)
  public partnerID: Maybe<string>;

  @Field(type => Int)
  public attendanceCount: Maybe<number>;
}
